import { render, staticRenderFns } from "./TechnicianGroup.vue?vue&type=template&id=dcba2e22&"
import script from "./TechnicianGroup.vue?vue&type=script&lang=js&"
export * from "./TechnicianGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports